import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as moment from 'moment';
import { first } from 'rxjs/operators';
import { IJurisdiction, Jurisdiction } from '../../../../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../../../../shared/base-components/base.component';
import { IOdometerReadingType, OdometerReadingType } from '../../../../../vehicle/models/enums/odometer-reading-type.enum';
import { IOdometerReadingUnitType, OdometerReadingUnitType } from '../../../../../vehicle/models/enums/odometer-reading-unit-type.enum';
import { ITitleSourceType, TitleSourceType } from '../../../../models/enums/title-source-type.enum';
import { TitleModel } from '../../../../models/title.model';
import { TitleRegistrationService } from '../../../../services/titleregistration.service';

export class TitleHistoryContextData {
    constructor(public vehicleId: number, public title: string) {}
}

@Component({
    selector: 'title-history-modal',
    templateUrl: './title-history-modal.html'
})
export class TitleHistoryModalComponent extends BaseComponent {
    public titles: TitleModel[];
    private odometerReadingType: OdometerReadingType = new OdometerReadingType();
    private odometerReadingUnitType: OdometerReadingUnitType = new OdometerReadingUnitType();
    private jurisdiction: Jurisdiction = new Jurisdiction();
    public odometerReadingTypes: IOdometerReadingType[];
    public odometerReadingUnitTypes: IOdometerReadingUnitType[];
    public titleSourceType: TitleSourceType = new TitleSourceType();
    public titleSourceTypes: ITitleSourceType[];
    public jurisdictions: IJurisdiction[];
    private vehicleId: number;
    public dataLoaded: boolean;
    private lookups: any;
    public title: string;

    constructor(public dialogRef: MatDialogRef<TitleHistoryModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: TitleHistoryContextData,
        private titleRegistrationService: TitleRegistrationService) {
        super();
        this.vehicleId = this.data.vehicleId;
        this.dataLoaded = false;
        this.title = this.data.title;
    }

    async ngOnInit() {
        try {
            this.odometerReadingTypes = this.odometerReadingType.GetAll();
            this.odometerReadingUnitTypes = this.odometerReadingUnitType.GetAll();
            this.jurisdictions = this.jurisdiction.GetAll();
            this.titleSourceTypes = this.titleSourceType.GetAll();
            this.titles = await this.titleRegistrationService.getTitleHistoryByVehicleId(this.vehicleId).pipe(first()).toPromise();
            this.dataLoaded = true;
        } catch (e) {
            this.dataLoaded = true;
            console.log(e);
        }
    }

    /**
     * Dismisses the modal.
     */
    cancel() {
        this.dialogRef.close();
    }

    /**
     * Formats the title issued date.  Will return an empty string if the date is 1/1/1900, as this
     * is a date from conversion that is used when the actual date is unknown.
     */
    public getFormattedTitleIssuedDate(title) {
        const issuedDate = moment(title.titleIssuedDate).toDate();
        if (issuedDate.getFullYear() === 0 || (issuedDate.getDate() === 1 && issuedDate.getMonth() === 0 && issuedDate.getFullYear() === 1900)) {
            return '';
        } else {
            return moment(title.titleIssuedDate).format('L');
        }
    }
}
